var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 43,
    viewBox: "0 0 58 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22949 7.1671V11.1532H54.7712V7.1671C54.7712 4.95561 52.9592 3.18099 50.7503 3.18099H7.25033C5.04147 3.18099 3.22949 4.95561 3.22949 7.1671ZM54.7712 35.8338V12.7365H3.22949V35.8338C3.22949 38.0453 5.04147 39.8199 7.25033 39.8199H50.7503C52.9592 39.8199 54.7712 38.0453 54.7712 35.8338ZM1.60449 7.1671C1.60449 4.1013 4.11858 1.59766 7.25033 1.59766H50.7503C53.8821 1.59766 56.3962 4.1013 56.3962 7.1671V35.8338C56.3962 38.8996 53.8821 41.4032 50.7503 41.4032H7.25033C4.11858 41.4032 1.60449 38.8996 1.60449 35.8338V7.1671ZM11.2712 31.056C11.2712 30.6336 11.6307 30.2643 12.0837 30.2643H26.5837C27.0366 30.2643 27.3962 30.6336 27.3962 31.056C27.3962 31.4784 27.0366 31.8477 26.5837 31.8477H12.0837C11.6307 31.8477 11.2712 31.4784 11.2712 31.056Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/paymentCard.048750ec.svg";
export { ForwardRef as ReactComponent };